import React from 'react';
import CampaignSmsInfoComponent from './campaign-sms-info.component';
import CampaignEmailInfoComponent from './campaign-email-info.component';
import CampaignWhatsappInfoComponent from './campaign-whatsapp-info.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import ListMarketingPlans from './plans';
import { PrepareEmailCampaign } from './prepare-email-campaign';

export const CampaignComponent = ({
  choosenCampaign,
  campaignFrequency,
  id,
  choosenWhatsappPlan,
  emailNotes,
  emailBudget,
  choosenEmailPlan,
  smsNotes,
  smsBudget,
  choosenSmsPlan,
  planNotes,
  selectedTemplate,
  setSelectedTemplate,
  choosenTemplate,
  handleInnerFormChange,
  back,
  rowData,
  columnDefs,
  setPageData,
  customerTags,
  choosenPlan,
  paginationData,
  vendorRowData,
  VendorpaginationData,
  vendorColumnDefs,
  agents,
  selectedPlansListRows
}: any) => {
  console.log(selectedPlansListRows,'selectedPlansListRowscomp')
  return (
    <>
      <PrepareEmailCampaign
        choosenCampaign={choosenCampaign}
        handleInnerFormChange={handleInnerFormChange} 
        campaignFrequency={campaignFrequency}
        customerTags={customerTags}
        emailNotes={emailNotes}
        emailBudget={emailBudget}
        choosenEmailPlan={choosenEmailPlan}   
        setSelectedTemplate={setSelectedTemplate}
        selectedTemplate={selectedTemplate}   
        choosenTemplate={choosenTemplate}
        id={id}
        rowData={rowData}
        columnDefs={columnDefs}
        setPageData={setPageData}
        paginationData={paginationData}
        vendorRowData={vendorRowData}
        VendorpaginationData={VendorpaginationData}
        vendorColumnDefs={vendorColumnDefs}
        agents={agents}
        selectedPlansListRows={selectedPlansListRows}
       />

      {/* <ListMarketingPlans 
        choosenCampaign={choosenCampaign}
        handleInnerFormChange={handleInnerFormChange} 
        campaignFrequency={campaignFrequency}
        customerTags={customerTags}
        emailNotes={emailNotes}
        emailBudget={emailBudget}
        choosenEmailPlan={choosenEmailPlan}   
        setSelectedTemplate={setSelectedTemplate}
        selectedTemplate={selectedTemplate}   
        choosenTemplate={choosenTemplate}
      /> */}

    {/* <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            >
            Back
            </button>
            <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleSubmit}
          
            type="submit"
        >
          Save
        </button>
    </div> */}
    </>
  );
};
export default CampaignComponent;
